// extracted by mini-css-extract-plugin
export default {"messageWrapper":"InfoMessage_messageWrapper__0WjSG","icon":"InfoMessage_icon__huNIW"};